<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="140px">
    <div style="width: 65%">
      <el-form-item label="快递公司编码" prop="fNumber">
        <el-input v-model="form.fNumber" />
      </el-form-item>
      <el-form-item label="快递公司名称" prop="fName">
        <el-input v-model="form.fName" />
      </el-form-item>

      <el-form-item label="物流单查询方式" prop="type">
        <el-select
          v-model="form.type"
          placeholder="请选择物流单查询方式"
          style="width: 100%"
        >
          <el-option label="按系统默认网址" value="按系统默认网址" />
          <el-option label="按指定网址" value="按指定网址" />
          <el-option label="不关联查询" value="不关联查询" />
        </el-select>
      </el-form-item>
    </div>
    <!-- <el-form-item label="创建时间" prop="fModifyTimestamp">
        <el-input :value="form.fModifyTimestamp | dateTimeFormat" />
      </el-form-item> -->
    <el-form-item label="物流单查询网址" prop="fExpressInquiry">
      <el-input v-model="form.fExpressInquiry" />
    </el-form-item>
    <div style="text-indent: 140px; color: red">
      <p style="margin: 0px">https://www.kuaidi100.com/chaxun?com=@dm&nu=@nu</p>
      <p style="margin: 0px">格式:[@dm:快递公司编号;@nu:物流单号]</p>
    </div>
  </el-form>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fNumber: [{ required: true, message: '必填项', trigger: 'change' }],
        fName: [{ required: true, message: '必填项', trigger: 'change' }],
        type: [{ required: true, message: '必填项', trigger: 'change' }],
        fCreateTime: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  //   computed: {
  //     isEdit: function() {
  //       return !!this.form.fRegionID;
  //     }
  //   },
  mounted: function() {},
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          onValid(this.form)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
